export default {
  common: {
    casino: "คาสิโน",
    more: "เพิ่มเติม",
    searchGames: "ค้นหาเกม",
    copied: "คัดลอกแล้ว!",
    inputTooLong: "ข้อมูลที่กรอกยาวเกินไป กรุณากรอกใหม่",
    inputNameCn: "อนุญาตเฉพาะตัวอักษรจีน อังกฤษ ตัวเลข และขีดล่างเท่านั้น",
    inputCapital: "อนุญาตเฉพาะตัวอักษรพิมพ์ใหญ่และขีดล่างเท่านั้น",
    inputLowercaseUnderscore: "อนุญาตเฉพาะตัวอักษรพิมพ์เล็กและขีดล่างเท่านั้น",
    inputLowercase: "อนุญาตเฉพาะตัวอักษรพิมพ์เล็กเท่านั้น",
    inputNoSpace: "กรุณาอย่ากรอกเฉพาะช่องว่าง",
    inputValidPhone: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    inputNonNumber: "มีอักขระที่ไม่ใช่ตัวเลข",
    inputNonLetter: "มีอักขระที่ไม่ใช่ตัวอักษร",
    inputLetterOrNumberOnly: "อนุญาตเฉพาะตัวอักษรหรือตัวเลขเท่านั้น",
    phoneFormatError: "รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง",
    inputLetterStartNumber: "ต้องขึ้นต้นด้วยตัวอักษรและอาจมีตัวเลขได้",
    inputNoChinese: "ไม่อนุญาตให้ใช้ตัวอักษรจีน",
    inputChineseOnly: "อนุญาตเฉพาะตัวอักษรจีนเท่านั้น",
    emailFormatError: "รูปแบบอีเมลไม่ถูกต้อง",
    urlFormatError: "รูปแบบ URL ไม่ถูกต้อง",
    jsonFormatError: "รูปแบบ JSON ไม่ถูกต้อง",
    networkError: "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ กรุณาลองใหม่อีกครั้งภายหลัง",
    siteUnavailable: "ขณะนี้ไซต์นี้ไม่พร้อมใช้งาน กรุณาติดต่อผู้ดูแลระบบ",
    tokenExpired: "เซสชันของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
    domainNotAuthorized: "โดเมนไม่ได้รับอนุญาต",
    demoEnvOnly: "สภาพแวดล้อมสาธิต สำหรับแสดงตัวอย่างเท่านั้น",
    passwordLength630: "6-30 ตัวอักษร",
    newPasswordSameAsOld: "รหัสผ่านใหม่ต้องไม่เหมือนกับรหัสผ่านเดิม",
    confirmNewPassword: "กรุณายืนยันรหัสผ่านใหม่ของคุณ",
    passwordsDoNotMatch: "รหัสผ่านไม่ตรงกัน",
    withdrawPasswordChanged: "เปลี่ยนรหัสผ่านถอนเงินสำเร็จ",
    withdrawPasswordSet: "ตั้งรหัสผ่านถอนเงินสำเร็จ",
    withdrawPasswordSetFailed: "ตั้งรหัสผ่านถอนเงินไม่สำเร็จ",
    phoneDigitsOnly: "หมายเลขโทรศัพท์ต้องเป็นตัวเลขเท่านั้น",
    phoneTooShort: "หมายเลขโทรศัพท์สั้นเกินไป (อย่างน้อย {min} หลัก)",
    phoneTooLong: "หมายเลขโทรศัพท์ยาวเกินไป (สูงสุด {max} หลัก)",
    phoneInvalidPrefix: "คำนำหน้าหมายเลขโทรศัพท์ไม่ถูกต้อง",
    rolloverAll: "ทุกประเภท",
    rolloverAllStats: "สถานะทั้งหมด",
    rolloverSuccessful: "สำเร็จ",
    rolloverFailed: "ล้มเหลว",
    rolloverInProgress: "กำลังดำเนินการ",
    rolloverSuccess: "สำเร็จ",
    rolloverPending: "รอดำเนินการ",
    rolloverCompleted: "เสร็จสมบูรณ์",
    rolloverCancelled: "ยกเลิกแล้ว",
    rolloverExpired: "หมดอายุ",
    walletCash: "เงินสด",
    walletBonus: "โบนัส",
    sourceDeposit: "ฝากเงิน",
    sourceCommission: "ค่าคอมมิชชั่น",
    sourceManualAdd: "เพิ่มด้วยตนเอง",
    sourceManualSubtract: "หักด้วยตนเอง",
  },
  redeemCode: {
    enterTip: "ป้อนรหัสแลกของรางวัลเพื่อรับรางวัล",
    placeholder: "กรุณาใส่รหัสของคุณ",
    redeemBtn: "แลกรางวัล",
    pleaseEnterCode: "กรุณาใส่รหัสแลกของรางวัล",
    redeemSuccess: "แลกรางวัลสำเร็จ!",
    redeemFailed: "แลกรางวัลล้มเหลว กรุณาลองอีกครั้ง",
  },
}
